import type { User } from '../types';

export type AudienceFace = 'public' | 'kids' | 'adults';

const getAgeFromDateOfBirth = (dateOfBirth?: string): number | null => {
  if (!dateOfBirth) {
    return null;
  }

  const parsedDate = new Date(dateOfBirth);
  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  const today = new Date();
  let age = today.getFullYear() - parsedDate.getFullYear();
  const monthDifference = today.getMonth() - parsedDate.getMonth();
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < parsedDate.getDate())) {
    age -= 1;
  }

  return age;
};

export const resolveAudienceFace = (currentUser: User | null): AudienceFace => {
  if (!currentUser) {
    return 'public';
  }

  if (currentUser.role !== 'buyer') {
    return 'adults';
  }

  const age = getAgeFromDateOfBirth(currentUser.dateOfBirth);
  if (age === null) {
    return 'adults';
  }

  return age >= 18 ? 'adults' : 'kids';
};
